import React, { ReactElement, useContext, useEffect } from 'react'
import { ArtData } from '@/database/art'
import { TransactionType } from '@/database/types'
import HistoryBid from '@/components/details/history/HistoryBid'
import HistoryOffer from '@/components/details/history/HistoryOffer'
import HistoryBuy from '@/components/details/history/HistoryBuy'
import { Context } from '@/components/Context'
import { SpecificUpdate, UpdateSpecific, UpdateSpecificType } from '@/types/websocket'

const HistoryOverview = ({ artData }: { artData: ArtData | undefined }): ReactElement => {
    const { transactionTokenArray, setActiveSpecificUpdates } = useContext(Context)

    const transactions =
        artData?.tokenId && transactionTokenArray[artData.tokenId]
            ? transactionTokenArray[artData.tokenId].filter(
                  (transaction) =>
                      transaction.type === TransactionType.BID ||
                      transaction.type === TransactionType.OFFER ||
                      transaction.type === TransactionType.BUY,
              )
            : []

    useEffect(() => {
        if (artData) {
            setActiveSpecificUpdates({
                updates: [
                    {
                        type: UpdateSpecificType.TRANSACTION_TOKEN,
                        id: artData.tokenId,
                    } as UpdateSpecific,
                ],
            } as SpecificUpdate)
        }
    }, [artData])

    return (
        <div>
            {artData && transactions?.length ? (
                <div>
                    {transactions
                        .sort((a, b) => {
                            // Convert to Date objects if not already, and handle potential null/undefined
                            const dateA = new Date(a.createdAt ?? 0) // Fallback to epoch if undefined/null
                            const dateB = new Date(b.createdAt ?? 0)
                            return dateB.getTime() - dateA.getTime()
                        })
                        .map((transaction) => {
                            switch (transaction.type) {
                                case TransactionType.BID: {
                                    return (
                                        <HistoryBid
                                            key={`#history-${transaction.id}`}
                                            artData={artData}
                                            transaction={transaction}
                                        />
                                    )
                                }
                                case TransactionType.OFFER: {
                                    return <HistoryOffer key={`#history-${transaction.id}`} transaction={transaction} />
                                }
                                case TransactionType.BUY: {
                                    return <HistoryBuy key={`#history-${transaction.id}`} transaction={transaction} />
                                }
                                default: {
                                    return ''
                                }
                            }
                        })}
                </div>
            ) : (
                <div className={'white'}>No History recorded yet</div>
            )}
        </div>
    )
}

export default HistoryOverview
